import { Observable } from 'rxjs';
import { SendVoucherRequest, VoucherMode } from '@app/data/dtos/tpv/voucher.dto';

/**
 * Port abstracto para los comprobantes (vouchers) de transacciones del TPV.
 * Lectura de la URL del comprobante y envío por SMS/WhatsApp/email.
 */
export abstract class VoucherRepository {
  /** Devuelve la URL del comprobante de la transacción según el `mode`. */
  abstract getVoucherUrl(idTransaction: string, mode: VoucherMode): Observable<string>;

  /** Envía el comprobante por el canal indicado. */
  abstract sendVoucher(idTransaction: string, request: SendVoucherRequest): Observable<void>;
}
